import {
  Box,
} from "@chakra-ui/react";
import { UseFormReturn } from "react-hook-form";
import { useCallback } from "react";
import { buildISODate } from "helpers/time";
import TimePickerField from "components/FormElements/Fields/TimePickerField";
import { GreyBlackLabel } from "components/DataDisplay/GreyBlackField";
import { longAttributeStyles } from "components/DataDisplay/styles";

interface TimeSelectFieldProps {
  label: string;
  datetimeFieldName: string;
  form: UseFormReturn<any>;
  labelProps?: object;
  sx?: object;
}

export default function TimeSelectField({
  form, label, datetimeFieldName, labelProps = {}, sx = {}, ...rest
}: TimeSelectFieldProps) {
  const { setValue, getValues, control, formState: { errors } } = form;
  const timezoneFieldName = "timezone";
  const dateFieldName = `local.${datetimeFieldName}.date`;
  const timeFieldName = `local.${datetimeFieldName}.timeOfDay`;

  const handleTimeChange = useCallback(
    (newTime: string) => {
      if (newTime) {
        const [triggerDate, timezone] = getValues([dateFieldName, timezoneFieldName]);
        const newIsoDate = buildISODate(triggerDate, newTime, timezone);
        setValue(datetimeFieldName, new Date(newIsoDate), { shouldDirty: true });
        setValue(timeFieldName, newTime, { shouldDirty: true });
      }
    },
    [dateFieldName, datetimeFieldName, getValues, setValue, timeFieldName],
  );

  const [localTimeOfDay, localTimezone] = getValues([timeFieldName, timezoneFieldName]);
  if (!localTimeOfDay || !localTimezone) {
    return null;
  }
  return (
    <Box h="32px" width="350px">
      <TimePickerField
        label={<GreyBlackLabel label={label} {...labelProps} />}
        name={timeFieldName}
        formFieldProps={{ sideLayout: true, labelProps: { display: "flex", alignItems: "flex-end", ...longAttributeStyles.labelContainerProps } }}
        control={control}
        errors={errors}
        sx={{
          padding: "0",
          height: "32px !important",
          paddingTop: "0 !important",
          fontSize: "14px",
          textIndent: "3px",
          ...sx,
        }}
        onTimeChange={handleTimeChange}
        {...rest}
      />
    </Box>
  );
}

// I have a field that is:
// Send At (horizontal)

// ONE COMPONENT WITH MULTIPLE INPUTS
// DATE Picker
// at
// Time Picker
// (Timezone picker)

//
